import { module as BaseModule } from 'modujs'

export default class extends BaseModule {
  init() {
    this.trigger = this.el.querySelector('[data-lang-switcher-trigger]')
    this.panel = this.el.querySelector('[data-lang-switcher-panel]')

    if (!this.trigger || !this.panel) {
      return
    }

    this.isOpen = false

    this.onTriggerClick = (event) => {
      event.preventDefault()
      event.stopPropagation()
      this.toggle()
    }

    this.onDocumentClick = (event) => {
      if (!this.isOpen) {
        return
      }
      if (this.el.contains(event.target)) {
        return
      }
      this.close()
    }

    this.onKeydown = (event) => {
      if (!this.isOpen) {
        return
      }
      if (event.key === 'Escape') {
        event.preventDefault()
        this.close()
        this.trigger.focus()
      }
    }

    this.trigger.addEventListener('click', this.onTriggerClick)
    document.addEventListener('click', this.onDocumentClick)
    document.addEventListener('keydown', this.onKeydown)
  }

  toggle() {
    if (this.isOpen) {
      this.close()
      return
    }
    this.open()
  }

  open() {
    this.isOpen = true
    this.el.classList.add('is-open')
    this.trigger.setAttribute('aria-expanded', 'true')
    this.panel.hidden = false
  }

  close() {
    this.isOpen = false
    this.el.classList.remove('is-open')
    this.trigger.setAttribute('aria-expanded', 'false')
    this.panel.hidden = true
  }

  destroy() {
    this.trigger?.removeEventListener('click', this.onTriggerClick)
    document.removeEventListener('click', this.onDocumentClick)
    document.removeEventListener('keydown', this.onKeydown)
  }
}
